import React, { useRef, useState } from 'react'
import BaseBottomSheetPopup from '../../../../components/BasicComponent/BaseBottomSheetPopup'
import BaseButton from '../../../../components/BasicComponent/BaseButton'
import FixedBottom from '../../../../components/BasicComponent/FixedBottom'
import LoadingScreen from '../../../../components/BasicComponent/LoadingScreen'
import { IconCheckCircleGreen, IconInfoCircle } from '../../../../assets/icons'
import PackageVehicleItem from '../PackageVehicleItem'
import '../../index.scss'

export default function Layout1({
  products,
  selectedProduct,
  selectedProductId,
  setSelectedProductId,
  isLoadingProducts,
  hasLoadError,
  productDetailItems,
  handleRetryLoadProducts,
  handleNextStep
}) {
  const packageListRef = useRef(null)
  const isPackageDraggingRef = useRef(false)
  const packageDragStartXRef = useRef(0)
  const packageDragScrollLeftRef = useRef(0)
  const packageDragMovedRef = useRef(false)

  const handlePackageListMouseDown = (event) => {
    const packageListElement = packageListRef.current
    if (!packageListElement) return
    isPackageDraggingRef.current = true
    packageDragMovedRef.current = false
    packageDragStartXRef.current = event.pageX - packageListElement.offsetLeft
    packageDragScrollLeftRef.current = packageListElement.scrollLeft
    packageListElement.classList.add('is-dragging')
  }

  const handlePackageListMouseMove = (event) => {
    const packageListElement = packageListRef.current
    if (!isPackageDraggingRef.current || !packageListElement) return
    event.preventDefault()
    const x = event.pageX - packageListElement.offsetLeft
    const walk = x - packageDragStartXRef.current
    if (Math.abs(walk) > 4) {
      packageDragMovedRef.current = true
    }
    packageListElement.scrollLeft = packageDragScrollLeftRef.current - walk
  }

  const handlePackageListMouseUp = () => {
    const packageListElement = packageListRef.current
    isPackageDraggingRef.current = false
    if (packageListElement) {
      packageListElement.classList.remove('is-dragging')
    }
    setTimeout(() => {
      packageDragMovedRef.current = false
    }, 0)
  }

  const handlePackageListWheel = (event) => {
    const packageListElement = packageListRef.current
    if (!packageListElement) return
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      event.preventDefault()
      packageListElement.scrollLeft += event.deltaY
    }
  }

  const [isRenewalInfoPopupOpen, setIsRenewalInfoPopupOpen] = useState(false)

  return (
    <>
      <div className="TrafficFineNotificationServices">
        {hasLoadError && !isLoadingProducts ? (
          <div className="TrafficFineNotificationServices_empty">{'Đã xảy ra lỗi, vui lòng thử lại sau'}</div>
        ) : (
          <>
            <div className="TrafficFineNotificationServices_section">
              <div className="TrafficFineNotificationServices_title">Chọn gói đăng ký</div>
              {!isLoadingProducts && products.length ? (
                <div
                  ref={packageListRef}
                  className="TrafficFineNotificationServices_packageList"
                  onMouseDown={handlePackageListMouseDown}
                  onMouseMove={handlePackageListMouseMove}
                  onMouseUp={handlePackageListMouseUp}
                  onMouseLeave={handlePackageListMouseUp}
                  onWheel={handlePackageListWheel}>
                  {products.map((product) => (
                    <PackageVehicleItem
                      key={product.productId}
                      product={product}
                      active={Number(product?.productId) === Number(selectedProductId)}
                      onClick={() => {
                        if (packageDragMovedRef.current) return
                        setSelectedProductId(product.productId)
                      }}
                    />
                  ))}
                </div>
              ) : !isLoadingProducts ? (
                <div className="TrafficFineNotificationServices_empty">{'Chưa có gói dịch vụ phù hợp.'}</div>
              ) : null}
            </div>

            {selectedProduct ? (
              <div className="TrafficFineNotificationServices_detailList">
                {productDetailItems.map((item) => (
                  <div
                    key={item.key}
                    className={`TrafficFineNotificationServices_detailItem ${
                      item.subValue ? 'TrafficFineNotificationServices_detailItem_subValue' : ''
                    }`.trim()}>
                    <div className="TrafficFineNotificationServices_detailLeft">
                      <div className="TrafficFineNotificationServices_detailIcon">{item.icon}</div>
                      <div className="TrafficFineNotificationServices_detailLabel">{item.label}</div>
                    </div>

                    {item.value ? (
                      <div className="TrafficFineNotificationServices_detailValueWrap">
                        <div className="TrafficFineNotificationServices_detailValue">{item.value}</div>
                        {item.subValue ? (
                          <button
                            type="button"
                            className="TrafficFineNotificationServices_detailSubValue"
                            aria-label="Xem thông tin nguồn tiền gia hạn"
                            // onClick={() => setIsRenewalInfoPopupOpen(true)}
                          >
                            <span>{item.subValue}</span>
                          </button>
                        ) : null}
                      </div>
                    ) : (
                      <div className="TrafficFineNotificationServices_detailStatus">
                        {item.isActive ? (
                          <IconCheckCircleGreen className="TrafficFineNotificationServices_detailStatusIcon" />
                        ) : (
                          <span className="TrafficFineNotificationServices_detailStatusPlaceholder" />
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : null}
          </>
        )}
      </div>

      <FixedBottom elementPaddingBottom="LayoutPartner">
        <div className="TrafficFineNotificationServices_bottom">
          {hasLoadError && !isLoadingProducts ? (
            <BaseButton onClick={handleRetryLoadProducts}>Thử lại</BaseButton>
          ) : (
            <BaseButton disabled={!selectedProduct} onClick={handleNextStep}>
              Tiếp theo
            </BaseButton>
          )}
        </div>
      </FixedBottom>
      <LoadingScreen open={isLoadingProducts} />
      <BaseBottomSheetPopup
        open={isRenewalInfoPopupOpen}
        onClose={() => setIsRenewalInfoPopupOpen(false)}
        title="Nguồn tiền gia hạn"
        className="TrafficFineNotificationServices_renewalPopup">
        <div className="TrafficFineNotificationServices_renewalPopupContent">
          <IconInfoCircle className="TrafficFineNotificationServices_renewalPopupIcon" />
          <div className="TrafficFineNotificationServices_renewalPopupText">
            <p>Tự động gia hạn gói khi hết chu kỳ.</p>
            <p>
              Trong đó, nguồn tiền gia hạn gói bao gồm: ViettelPay, Tiền di động, các ngân hàng liên kết trực tiếp với Viettel
              Money (tuỳ thuộc chính sách, quy định của từng ngân hàng).
            </p>
            <p>Để dừng gia hạn, bạn vui lòng truy cập vào mục "Quản lý đăng ký" và huỷ gia hạn tự động.</p>
          </div>
        </div>
      </BaseBottomSheetPopup>
    </>
  )
}
